import { AfterViewInit, Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, map, merge, of, Subscription } from 'rxjs';
import { LoginService } from '../api/auth/login.service';
import { ConfigService } from '../api/core/config.service';
import { GlobalService } from '../api/global.service';
import { environment } from '../environment';
import AlertifyHelper from '../utils/utils';
declare var $: any;

@Component({
  selector: 'app-main-sys',
  templateUrl: './main-sys.component.html',
  styleUrls: ['./main-sys.component.css']
})
export class MainSysComponent implements OnInit {
  title = 'notas';
  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;
  public branchofficeSlug: string = '';
  modules: any = [];
  nameApp: string = 'Nombre App';
  public user: any;

  company:any = null;
  activation:any = null;

  constructor(
    private el: ElementRef,
    private router: Router,
    private configService: ConfigService,
    private globalService: GlobalService,
    private authService: LoginService,
    private alertifyMsg: AlertifyHelper
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.nameApp = environment.name_app;
    this.user = this.authService.getUser();
  }

  ngOnInit(): void {
    this.checkNetworkStatus();
    this.getModules();
  }

  getModules() {
    this.showloader();
    this.configService.modulesSystem().subscribe({
      next: (data: any) => {
        this.modules = data.modules;
        this.saveModuleStorage(this.modules);        
        this.hideloader();
        setTimeout(() => {
          this.refreshSideMenu();
        }, 250);

        this.company = data.company;
        this.activation = data.activation;

        // guardar dato companía en cache
        localStorage.setItem('company', JSON.stringify(this.company));

        if(this.company.free_control){
          this.globalService.setPassActivation("activate");
        }else{
          if(this.activation != null){
            if(this.activation.days_available < 0){
              this.globalService.setPassActivation("not_activate");
              this.alertifyMsg.warning('Debe seleccionar la sucursal para poder continuar');
              this.router.navigate(['/admin/sucursales']);
            }else{
              this.globalService.setPassActivation("activate");              
            }
          }else{
            this.globalService.setPassActivation("not_activate");
            this.alertifyMsg.warning('Debe seleccionar la sucursal para poder continuar');
            this.router.navigate(['/admin/sucursales']);
          }
        }
      }
    });
  }

  saveModuleStorage(modules:any){
    localStorage.setItem('modulesSystem', JSON.stringify(modules));
  }

  refreshSideMenu() {
    (<any>$('#side-menu')).metisMenu();
    (<any>$('#sidebar-menu a')).each(function(index: any, element: any) {
      var pageUrl = window.location.href.split(/[?#]/)[1];
      // if (element.href == pageUrl) {
      if (element.href.split(/[?#]/)[1] == pageUrl) {
        (<any>$(element)).addClass('mm-active');
        (<any>$(element)).parent().addClass('mm-active'); // add active to li of the current link
        (<any>$(element))
          .parent()
          .parent()
          .addClass('mm-show');
        (<any>$(element))
          .parent()
          .parent()
          .prev()
          .addClass('mm-active'); // add active class to an anchor
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .addClass('mm-active');
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass('mm-show'); // add active to li of the current link
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass('mm-active');
      }
    });

    (<any>$('.slimscroll-menu')).slimscroll({
      height: 'auto',
      position: 'right',
      size: '7px',
      color: '#9ea5ab',
      wheelStep: 5,
      touchScrollStep: 50
    });

    (<any>$('.slimscroll')).slimscroll({
      height: 'auto',
      position: 'right',
      size: '7px',
      color: '#9ea5ab',
      touchScrollStep: 50
    });

    (<any>$('.button-menu-mobile')).on('click', function(event: any) {
      event.preventDefault();
      (<any>$('body')).toggleClass('enlarged');
    });

    if ((<any>$(window)).width() < 1025) {
      (<any>$('body')).addClass('enlarged');
    } else {
      if ((<any>$('body')).data('keep-enlarged') != true)
        (<any>$('body')).removeClass('enlarged');
    }

    (<any>$('[data-toggle="tooltip"]')).tooltip();
    (<any>$('[data-toggle="popover"]')).popover();
  }

  checkNetworkStatus() {
    this.networkStatus = navigator.onLine;
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    )
      .pipe(map(() => navigator.onLine))
      .subscribe(status => {
        this.networkStatus = status;
      });
  }

  loadParent(slug: string, separator: string, ref: string) {
    let url = slug + separator + ref;
    (<any>$('#sidebar-menu a')).each(function(index: any, element: any) {
      (<any>$(element)).removeClass('mm-active');
      (<any>$(element)).parent().removeClass('mm-active'); // add active to li of the current link
      (<any>$(element))
        .parent()
        .parent()
        .removeClass('mm-show');
      (<any>$(element))
        .parent()
        .parent()
        .prev()
        .removeClass('mm-active'); // add active class to an anchor
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .removeClass('mm-active');
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .parent()
        .removeClass('mm-show'); // add active to li of the current link
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .parent()
        .parent()
        .removeClass('mm-active');
    });

    let menu_parent = <any>$('a[href^="#/' + url + '"]');
    menu_parent.addClass('mm-active');
    menu_parent
      .parent()
      .parent()
      .addClass('mm-active');
  }

  childLoadMenu(slug: string, separator: string, ref: string) {
    let url = slug + separator + ref;
    (<any>$('#sidebar-menu a')).each(function(index: any, element: any) {
      (<any>$(element)).removeClass('mm-active');
      (<any>$(element)).parent().removeClass('mm-active'); // add active to li of the current link
      (<any>$(element))
        .parent()
        .parent()
        .removeClass('mm-show');
      (<any>$(element))
        .parent()
        .parent()
        .prev()
        .removeClass('mm-active'); // add active class to an anchor
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .removeClass('mm-active');
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .parent()
        .removeClass('mm-show'); // add active to li of the current link
      (<any>$(element))
        .parent()
        .parent()
        .parent()
        .parent()
        .parent()
        .removeClass('mm-active');
    });

    let menu_child = <any>$('a[href^="#/' + url + '"]');
    menu_child.addClass('mm-active');
    menu_child.parent('li').addClass('active'); // add active to li of the current link
    menu_child
      .parent()
      .parent()
      .addClass('mm-show');
    menu_child
      .parent()
      .parent()
      .prev()
      .addClass('mm-active'); // add active class to an anchor
    menu_child
      .parent()
      .parent()
      .parent()
      .addClass('mm-active');
    menu_child
      .parent()
      .parent()
      .parent()
      .parent()
      .addClass('mm-show'); // add active to li of the current link
    menu_child
      .parent()
      .parent()
      .parent()
      .parent()
      .parent()
      .addClass('mm-active');
  }

  initMetisMenu() {
    (<any>$('#side-menu')).metisMenu();
    (<any>$('#sidebar-menu a')).each(function(index: any, element: any) {
      var pageUrl = window.location.href.split(/[?#]/)[0];
      if (element.href == pageUrl) {
        (<any>$(element)).addClass('mm-active');
        (<any>$(element)).parent().addClass('mm-active'); // add active to li of the current link
        (<any>$(element))
          .parent()
          .parent()
          .addClass('mm-show');
        (<any>$(element))
          .parent()
          .parent()
          .prev()
          .addClass('mm-active'); // add active class to an anchor
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .addClass('mm-active');
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass('mm-show'); // add active to li of the current link
        (<any>$(element))
          .parent()
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass('mm-active');
      }
    });
  }

  intSlimscrollmenu() {
    (<any>$('.slimscroll-menu')).slimscroll({
      height: 'auto',
      position: 'right',
      size: '7px',
      color: '#9ea5ab',
      wheelStep: 5,
      touchScrollStep: 50
    });
  }

  initSlimscroll() {
    (<any>$('.slimscroll')).slimscroll({
      height: 'auto',
      position: 'right',
      size: '7px',
      color: '#9ea5ab',
      touchScrollStep: 50
    });
  }

  initLeftMenuCollapse() {
    (<any>$('.button-menu-mobile')).on('click', function(event: any) {
      event.preventDefault();
      (<any>$('body')).toggleClass('enlarged');
    });
  }

  initEnlarge() {
    if ((<any>$(window)).width() < 1025) {
      (<any>$('body')).addClass('enlarged');
    } else {
      if ((<any>$('body')).data('keep-enlarged') != true)
        (<any>$('body')).removeClass('enlarged');
    }
  }

  initComponents() {
    (<any>$('[data-toggle="tooltip"]')).tooltip();
    (<any>$('[data-toggle="popover"]')).popover();
  }

  logout() {
    this.showloader();
    this.authService.logout().subscribe(
      data => {
        this.authService.removeToken();
        this.authService.removeUserData();
        this.authService.removeUserPermissions();
        this.hideloader();
        this.router.navigate(["/login"]);
      },
      error => {
        console.log(error);
      }
    )
  }

  showloader() {
    (<HTMLInputElement>document.getElementById('loading')).style.display =
      'block';
  }

  hideloader() {
    (<HTMLInputElement>document.getElementById('loading')).style.display =
      'none';
  }
}
